import type { ReactNode } from "react";
import classNames from "classnames";
import { Table } from "@circle-react-uikit/TableV2";

export interface FootProps {
  children: ReactNode;
  className?: string;
}

export const Foot = ({ className, children }: FootProps) => (
  <Table.TableFoot className={classNames("py-3", className)}>
    {children}
  </Table.TableFoot>
);
